/**
 * @generated SignedSource<<18677282b7a3c9a7345c7c2edf326e3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SheetRendererNoteBox_box$data = {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly " $fragmentType": "SheetRendererNoteBox_box";
};
export type SheetRendererNoteBox_box$key = {
  readonly " $data"?: SheetRendererNoteBox_box$data;
  readonly " $fragmentSpreads": FragmentRefs<"SheetRendererNoteBox_box">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SheetRendererNoteBox_box",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "y",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    }
  ],
  "type": "Box",
  "abstractKey": null
};

(node as any).hash = "54526b9422b7a31b8c5ec6a2c232dba3";

export default node;
